import { Boolean, Number, Record, Static, String } from "runtypes";

export const SurveyResponseRuntype = Record({
  survey: Record({
    coachCode: String,
    enableParentQuestions: Boolean,
    id: Number,
    parentCode: String,
    studentCode: String,
    type: Number,
  }),
});

export interface ISurveyResponse extends Static<typeof SurveyResponseRuntype> {}



// WEBPACK FOOTER //
// ./src/api/types/ISurveyResponse.ts